"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _clsx6 = _interopRequireDefault(require("clsx"));
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _commonLibs = require("@mmc/common-libs");
var _commonHeading = require("@mmc/common-heading");
var _commonCta = require("@mmc/common-cta");
var _utils = require("../utils");
var _actions = require("../store/actions");
var _commonSetLocation = require("./common-set-location.propTypes");
var _commonSetLocation2 = _interopRequireDefault(require("./common-set-location.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_ERROR_MESSAGE = 'Cannot locate your current location';
var FADEOUT_MS = 100;
var instanceId = 0;
var getInputId = function getInputId() {
  return "commonSetLocation_searchInput_" + instanceId;
};
var geocoder;
var CommonSetLocation = function CommonSetLocation(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5;
  var id = _ref.id,
    className = _ref.className,
    data = _ref.data,
    _ref$dark = _ref.dark,
    dark = _ref$dark === void 0 ? true : _ref$dark,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? true : _ref$padding,
    googleAPIKey = _ref.googleAPIKey,
    language = _ref.language,
    market = _ref.market,
    theme = _ref.theme,
    onUnmount = _ref.onUnmount,
    disappearAfterLocationSet = _ref.disappearAfterLocationSet,
    globalLocation = _ref.globalLocation,
    dispatch = _ref.dispatch,
    onLocationSelected = _ref.onLocationSelected;
  (0, _commonLibs.useConstructor)(function () {
    if (!id) instanceId += 1;
  });
  var inputRef = (0, _react.useRef)(null);
  var inputId = (0, _react.useRef)(id || getInputId()).current;
  var _useState = (0, _react.useState)(false),
    fading = _useState[0],
    setFading = _useState[1];
  var _useState2 = (0, _react.useState)(''),
    error = _useState2[0],
    setError = _useState2[1];
  var shouldRenderChild = (0, _commonLibs.useDelayUnmount)(!fading, FADEOUT_MS, onUnmount);
  var errorMessage = data.noGeolocationMessage || data.errorMessage || DEFAULT_ERROR_MESSAGE;
  var showTitleOrDescription = Boolean(data.title || data.description);
  var containerInnerStyle = padding ? (0, _clsx6["default"])(theme['col-xs-10'], theme['col-xs-offset-1']) : _commonSetLocation2["default"].containerInner;
  var themeStyles = (0, _clsx6["default"])(dark && [_commonSetLocation2["default"].dark, theme.dark]);
  var columnStyles = (0, _clsx6["default"])(showTitleOrDescription && [theme['col-xs-12'], theme['col-sm-6'], theme['col-md-6'], _commonSetLocation2["default"].iconColumnMargin]);
  var updateAndStoreUserLocation = function updateAndStoreUserLocation(location) {
    if (location.userLocation) {
      dispatch((0, _actions.storeGlobalLocation)(location));
      if (typeof window !== 'undefined' && window.dataLayer) {
        var title = typeof window.document !== 'undefined' && window.document.title;
        window.dataLayer.push(_objectSpread({
          event: 'location_search',
          searchLocation: title,
          component: data.resourceType || 'LocationSelector_1_0_0'
        }, location));
      }
    }
  };
  var getGoogleGeolocation = function getGoogleGeolocation(lookup) {
    setError('');
    var input = inputRef.current;
    input.classList.add(_commonSetLocation2["default"].close);
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _utils.getPostalCodeFromGooglePlaceResults)(results);
        var locality = (0, _utils.getLocalityFromGooglePlaceResults)(results);
        var stateCode = (0, _utils.getStateCodeFromGooglePlaceResults)(results);
        var city = (0, _utils.getCityFromGooglePlaceResults)(results);
        var userLocation = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        if (locality || userLocation) {
          var location = {
            searchValue: locality || lookup.address,
            stateCode: stateCode,
            userLocation: userLocation,
            postalCode: postalCode,
            city: city
          };
          _commonLibs.EventEmitter.dispatch('locationChangeEvent', location);
          dispatch((0, _actions.setGlobalLocation)(location));
          updateAndStoreUserLocation(location);
          _commonLibs.EventEmitter.dispatch('locationChangeFooter', location);
          if (onLocationSelected) {
            onLocationSelected(location);
          }
          if (postalCode) {
            (0, _commonLibs.setUserPostalCodeInDealerCache)(postalCode);
          } else {
            retryGeocodeWithLatlng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          }
          if (disappearAfterLocationSet) {
            setFading(true);
          }
          return;
        }
      }
      setError(errorMessage);
    });
  };
  var retryGeocodeWithLatlng = function retryGeocodeWithLatlng(lat, lng) {
    var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var lookup = {
      latLng: latLng
    };
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _utils.getPostalCodeFromGooglePlaceResults)(results);
        (0, _commonLibs.setUserPostalCodeInDealerCache)(postalCode);
        (0, _utils.setUpdatedPostalCodeInCachedLocation)(postalCode);
      }
    });
  };
  var onInputChange = function onInputChange(e) {
    if (onLocationSelected) {
      onLocationSelected('');
    }
    dispatch((0, _actions.setGlobalLocation)({
      searchValue: e.target.value
    }));
  };
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    getGoogleGeolocation({
      address: globalLocation.searchValue
    });
  };
  var onAutocompleteChange = function onAutocompleteChange(address) {
    dispatch((0, _actions.setGlobalLocation)({
      searchValue: address
    }));
    getGoogleGeolocation({
      address: address
    });
  };
  var getNavigatorGeolocation = function getNavigatorGeolocation(e) {
    // prevent default to prevent form submit
    e.preventDefault();
    if (!navigator.geolocation) {
      setError(errorMessage);
      return;
    }
    var onGetPositionSuccess = function onGetPositionSuccess(position) {
      var location = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      getGoogleGeolocation({
        location: location
      });
    };
    var onGetPositionError = function onGetPositionError() {
      setError(errorMessage);
    };
    navigator.geolocation.getCurrentPosition(onGetPositionSuccess, onGetPositionError, {
      timeout: 5000
    });
  };
  (0, _react.useEffect)(function () {
    (0, _commonLibs.loadScript)({
      google: (0, _commonLibs.getGoogleApiURL)({
        apiKey: googleAPIKey,
        libraries: ['places', 'geometry'],
        region: market || null,
        language: language || null
      })
    }).google.onLoad(function () {
      geocoder = new window.google.maps.Geocoder();
      (0, _utils.bindGoogleAutocompleteToInput)(inputRef.current, market, onAutocompleteChange);
    });
  }, []);

  // fix form sumbit invocation on selecting location from dropdown using keyboard
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    };
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
    }
    return function () {
      var _inputRef$current;
      inputRef == null ? void 0 : (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.removeEventListener('keydown', handleKeyDown);
    };
  }, [inputRef.current]);

  // Remove Entered location on clicking the close button
  var clearDealerLocation = function clearDealerLocation(e) {
    if (onLocationSelected) {
      onLocationSelected('');
    }
    var input = inputRef.current;
    input.classList.remove(_commonSetLocation2["default"].close);
    dispatch((0, _actions.setGlobalLocation)({
      searchValue: ''
    }));
    input.focus();
  };
  var searchValue = globalLocation.searchValue;
  var isTypeError = function isTypeError(type) {
    return type === 'error';
  };
  return shouldRenderChild && /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
    skip: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      transition: "opacity ease-out " + FADEOUT_MS + "ms"
    },
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].commonSetLocation, themeStyles, className, (_clsx = {}, _clsx[_commonSetLocation2["default"].fade] = fading, _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: containerInnerStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(showTitleOrDescription && theme.row)
  }, showTitleOrDescription && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].headingsContainer, columnStyles)
  }, data.title && /*#__PURE__*/_react["default"].createElement(_commonHeading.CommonHeading, {
    tag: "div",
    text: data.title,
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].title, themeStyles)
  }), data.description && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].searchDescription, theme.bodyCopy, themeStyles)
  }, data.description)), /*#__PURE__*/_react["default"].createElement("form", {
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].form, columnStyles),
    onSubmit: onSubmit,
    tabIndex: "-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _commonSetLocation2["default"].inputContainer
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: _commonSetLocation2["default"].searchInputLabel,
    htmlFor: inputId
  }, data.inputLocationLabel), /*#__PURE__*/_react["default"].createElement("input", {
    id: inputId,
    ref: inputRef,
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].searchInput, (_clsx2 = {}, _clsx2[_commonSetLocation2["default"].focused] = Boolean(searchValue), _clsx2)),
    type: "text",
    value: searchValue,
    placeholder: "",
    onChange: onInputChange,
    autoComplete: "false",
    tabIndex: "-1"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].ctaContainer, themeStyles)
  }, searchValue && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].clearButton, (_clsx3 = {}, _clsx3[_commonSetLocation2["default"].clearButtonImgDark] = Boolean(dark), _clsx3[_commonSetLocation2["default"].clearButtonImgLight] = !Boolean(dark), _clsx3)),
    onClick: clearDealerLocation,
    "aria-label": "clear button"
  }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "-1",
    disabled: !searchValue,
    spanClasses: _commonSetLocation2["default"].submitBtn,
    data: {
      priority: 'lowIcon',
      icon: 'Search',
      ctaProps: {
        type: 'submit',
        'aria-label': 'Location search'
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx6["default"])(_commonSetLocation2["default"].errorMessage, (_clsx4 = {}, _clsx4[_commonSetLocation2["default"].visible] = error, _clsx4))
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx6["default"])((_clsx5 = {}, _clsx5[theme.mmcIconFormError] = isTypeError('error'), _clsx5))
  }), " ", error), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(themeStyles, _commonSetLocation2["default"].userCurrentLocationContainer)
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "0",
    clickEvent: getNavigatorGeolocation,
    data: {
      label: data.useCurrentLocationLabel,
      priority: 'lowIcon',
      icon: 'Pointer'
    }
  })))))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    googleAPIKey: props.googleApiKey || state.Config.googleApiKey,
    language: props.language || state.Config.language,
    market: props.market || state.Config.market,
    globalLocation: props.globalLocation || state.globalLocation
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(CommonSetLocation);
exports["default"] = _default;